import { render, staticRenderFns } from "./SaveErrorDialog.vue?vue&type=template&id=47a44b88&"
import script from "./SaveErrorDialog.vue?vue&type=script&lang=js&"
export * from "./SaveErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./SaveErrorDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaveErrorDialog.vue"
export default component.exports